/**
 * Dimensions Tab
 * Displays extracted dimension information
 */

import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Alert
} from '@mui/material';
import { Straighten as DimensionIcon } from '@mui/icons-material';
import { Dimension } from '../../types/bom.types';

interface DimensionsTabProps {
  dimensions: Dimension[];
}

const DimensionsTab: React.FC<DimensionsTabProps> = ({ dimensions }) => {
  if (!dimensions || dimensions.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Alert severity="info">
          No dimension data available. Extract from a page first.
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <DimensionIcon color="primary" />
        <Typography variant="h6">
          Dimension Information ({dimensions.length})
        </Typography>
      </Box>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'primary.main' }}>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Type</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Value</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Unit</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Tolerance</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Page</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dimensions.map((dimension, index) => (
              <TableRow key={index} hover>
                <TableCell>
                  <Typography variant="body2" fontWeight={600}>
                    {dimension.type || 'Unknown'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {dimension.value || 'N/A'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip 
                    label={dimension.unit || 'N/A'} 
                    size="small" 
                    variant="outlined"
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {dimension.tolerance || 'N/A'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {dimension.page || 'N/A'}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DimensionsTab;

